import NotificationClient from '../../../api/notification';
import {
	createNotificationSubscription,
	getUserSubscription,
	unsubscribeNotification,
	updateLocalStorageDoNotAsk,
	updateLocalStorage,
	askUserPermission
} from './../../../push-notifications';
import { toast } from 'react-toastify';

export const dialogs = {
	state: {
		confirm: {
			isOpen: false
		},
		readingNotification: {
			isOpen: false
		},
		allowancebeingNotified: {
			isOpen: false,
			subject: `Você aceita receber notificações ?`,
			message: `Esta aplicação utiliza notificações para lhe alertar de atualizações. Você deseja receber esses alertas ?`,
			subscription: {}
		}
	},
	reducers: {
		setConfirmDialog(state, payload) {
			return {
				...state,
				confirm: {
					...payload
				}
			}
		},
		readingNotification(state, payload) {
			return {
				...state,
				readingNotification: {
					...state.readingNotification,
					...payload
				}
			};
		},
		setNotificationAllowance(state, payload) {
			return {
				...state,
				allowancebeingNotified: {
					...state.allowancebeingNotified,
					...payload
				}
			};
		},
		clearStore() {
			return {};
		}
	},
	effects: (dispatch) => ({
		setConfirmDialogAsync(payload) {
			return this.setConfirmDialog(payload);
		},

		closeConfirmDialogAsync() {
			const payload = {
				isOpen: false
			};
			return this.setConfirmDialog(payload);
		},
		openReadingNotificationDialog(notification) {
			const payload = {
				isOpen: notification.isOpen,
				subject: notification.subject,
				message: notification.message,
				url: notification.url
			};

			return this.readingNotification(payload);
		},
		closeReadingNotificationDialog() {
			const payload = {
				isOpen: false
			};
			return this.readingNotification(payload);
		},
		setAllowanceDialog() {
			const payload = {
				isOpen: false
			};
			return this.setNotificationAllowance(payload);
		},
		async subscribeUserToPush(payload, lastState) {
			try {
				this.setNotificationAllowance({ isOpen: false });
				const consent = await askUserPermission();
				const { auth: { user: { login } } } = lastState;
				if (consent === 'granted') {
					const subscrition = await createNotificationSubscription();
					let data = { ...subscrition };
					data = JSON.stringify(data);
					data = JSON.parse(data);

					data.key = btoa(String.fromCharCode.apply(null, new Uint8Array(subscrition.getKey('p256dh'))));
					data.token = btoa(String.fromCharCode.apply(null, new Uint8Array(subscrition.getKey('auth'))));

					const subscriptionTreated = JSON.stringify(data);

					const res = await NotificationClient.postSubscriptionToNotifications(subscriptionTreated);

					updateLocalStorage(res.data, login);

				} else {
					updateLocalStorageDoNotAsk(login);
				}
			} catch (error) {
				if (error.toString().match(/exists|ssl/i)) {
					unsubscribeNotification();
				} else if (error.toString().match(/certificate|ssl/i)) {
					toast.error(
						'Essa funcionalidade não está disponível em ambiente inseguro (ou certificado SSL inválido'
					);
				} else {
					toast.error('Ops, aglo deu errado :(', error);
				}
			}

			return;
		},
		async unSubscribeUserToPush(payload, lastState) {
			try {
				const { auth: { user: { login } } } = lastState;
				this.setNotificationAllowance({ isOpen: false });
				updateLocalStorageDoNotAsk(login);
				if (getUserSubscription()) {
					unsubscribeNotification();
				}
			} catch (error) {
				toast.error('Ops, aglo deu errado :(', error);
			}
			return;
		}
	})
};
